import React from 'react';
import PropTypes from 'prop-types';
import { hasValue } from '../../../general/js/general-helpers';
class RouteToHolePlayer extends React.Component {

    render() {
        const { videoSource } = this.props;

        return (
            <React.Fragment>
            {
                hasValue(videoSource) &&
                <video
                    autoPlay
                    playsInline
                    controls
                    x-webkit-airplay='allow'
                    width='100%'
                    height=''
                    src={videoSource}>
                </video>
            }
            </React.Fragment>
        );
    }
};

RouteToHolePlayer.propTypes = {
    videoSource: PropTypes.string.isRequired,
};

export default RouteToHolePlayer;
